module.exports = __webpack_public_path__ + "img/shouye_kehu03.bd850f8a.png";